<div id="slide-button">
  <button  (click)="changeState()" [ngClass]="{ active: isTrue }">
    <span></span>
    <span></span>
  </button>
  <span>
    <ng-content></ng-content>
  </span>
</div>
